export default "__VITE_ASSET__zesrNgiB__"